import * as React from "react";

const SvgSurveyBackground = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="currentColor"
    {...props}
  >
    <defs>
      <path
        d="M28.264 28.264c-1.542 1.621-3.604 2.608-6.185 2.96-1.812.37-3.888.525-6.229.462-2.341.063-4.418-.091-6.229-.462-2.581-.352-4.643-1.339-6.185-2.96C1.815 26.722.828 24.66.476 22.08c-.37-1.811-.525-3.888-.463-6.229-.062-2.341.093-4.418.463-6.229.352-2.581 1.339-4.643 2.96-6.185C4.978 1.815 7.04.828 9.62.476c1.811-.37 3.888-.525 6.23-.463 2.34-.062 4.416.092 6.228.463 2.581.352 4.643 1.339 6.185 2.96 1.621 1.542 2.608 3.604 2.96 6.185.37 1.811.525 3.888.462 6.23.063 2.34-.091 4.417-.462 6.228-.352 2.581-1.339 4.643-2.96 6.185z"
        id="survey-background_svg__a"
      />
      <path
        d="M7.36 15.176V8.271a1.119 1.119 0 0 1 .621-2.05 1.117 1.117 0 0 1 1.124 1.115c0 .454-.274.844-.657 1.016v6.824c0 .3-.247.544-.548.544a.54.54 0 0 1-.54-.544zm3.352-5.635a.538.538 0 0 0 .75-.181 3.92 3.92 0 0 0 .574-2.233c-.09-2.196-1.963-3.91-4.182-3.829a3.99 3.99 0 0 0-2.776 1.289 3.927 3.927 0 0 0-1.06 2.867c.028.626.192 1.225.493 1.77a.546.546 0 0 0 .75.208.546.546 0 0 0 .21-.744A3 3 0 0 1 5.104 7.4a2.935 2.935 0 0 1 .767-2.087c.52-.572 1.26-.89 2.037-.926 1.607-.064 2.977 1.18 3.04 2.786a2.833 2.833 0 0 1-.42 1.624.542.542 0 0 0 .183.744zm1.608 2.096c.228.19.575.163.776-.063a6.627 6.627 0 0 0 1.57-4.283C14.667 3.634 11.68.667 8 .667S1.333 3.634 1.333 7.29c0 1.66.621 3.24 1.745 4.464.11.118.255.182.401.182a.551.551 0 0 0 .402-.916A5.51 5.51 0 0 1 2.43 7.29c0-3.05 2.502-5.534 5.57-5.534 3.069 0 5.57 2.486 5.57 5.535a5.523 5.523 0 0 1-1.314 3.575.537.537 0 0 0 .064.771z"
        id="survey-background_svg__c"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="survey-background_svg__b" fill="#fff">
        <use xlinkHref="#survey-background_svg__a" />
      </mask>
      <use fill="#BABABA" xlinkHref="#survey-background_svg__a" />
      <g mask="url(#survey-background_svg__b)" fill="#DFE2E7">
        <path d="M0 0h32v32H0z" />
      </g>
      <g transform="translate(8 8)">
        <mask id="survey-background_svg__d" fill="#fff">
          <use xlinkHref="#survey-background_svg__c" />
        </mask>
        <use
          fill="#000"
          fillRule="nonzero"
          xlinkHref="#survey-background_svg__c"
        />
        <g mask="url(#survey-background_svg__d)" fill="#091E42">
          <path d="M0 0h16v16H0z" />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgSurveyBackground;
